@if (!navigatieVoorkeurService.nieuweNavigatie()) {
	<app-user-tab-menu [shareVisible]="shareVisible()" [exportVisible]="exportTypes().length > 0" (exportClicked)="startExport$.next(undefined)"></app-user-tab-menu>
}
<div class="hider" [class.show-sidebar]="filterService.filterPanelOpened$ | async">
	<app-click-blocking-overlay [enabled]="(filterService.filterPanelOpened$ | async) ?? false" (clicked)="filterService.filterPanelOpened$.next(false)"></app-click-blocking-overlay>
	<div class="spinner-overlay">
		@if (showSpinner$ | async) {
			<app-svg-spinner></app-svg-spinner>
		}
	</div>
	@if (filterbalkVisible()) {
		<div class="filterbalk">
			<ng-content select="app-filter-bar"></ng-content>
			@if (navigatieVoorkeurService.nieuweNavigatie()) {
				<app-dashboard-acties [shareVisible]="shareVisible()" [exportVisible]="exportTypes().length > 0" (exportClicked)="startExport$.next($event)"></app-dashboard-acties>
			}
		</div>
	}
	<ng-content></ng-content>
</div>
